import React from 'react';
import { Box, useTheme } from '@mui/material';

const logoUrl = `${process.env.PUBLIC_URL}/logo_.svg`;

export default function LogoWatermark() {
  const theme = useTheme();
  const opacity = theme.palette.mobile?.watermarkOpacity ?? 0.08;

  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src={logoUrl}
        alt=""
        sx={{
          width: 'min(85vw, 320px)',
          height: 'auto',
          opacity,
          filter:
            theme.palette.mode === 'dark'
              ? 'brightness(2) saturate(0.85)'
              : 'saturate(0.9)',
        }}
      />
    </Box>
  );
}
